import { IconDefinition } from "./types";

const loading: IconDefinition = {
  iconName: "loading",
  width: 16,
  height: 16,
  svgPathData: "M1.203 7.976a6.768 6.768 0 106.759-6.712",
  iconType: "stroke",
};

export { loading };
